import axios from "axios"
import { store } from "../main"
//import { UseErrorHandler } from "../function/UseErrorHandler"
import { useURL } from "../composables/useURL.js"
import { router } from '../main'

const SERVICE_PATH = '/healthyAI'
const { getParameterByName } = useURL();

const httpClient = axios.create({
    headers: {
        "Accept-Language": getParameterByName("lang")
    },
})
//const { apiErrorHandler } = UseErrorHandler();
const request = {
    get(path, params, isByteArray=false/*, authHandle=true*/) {
        //store.dispatch('session/sessionTimerRefresh')
        store.commit("Apps/setLoading");
        httpClient.defaults.headers["Accept-Language"] = getParameterByName("lang");
        var param={params: params};
        if (isByteArray) param["responseType"]="arraybuffer";
        return httpClient.get(`${SERVICE_PATH}/${path}`, param)
            .then(response => {
                store.commit("Apps/setLoaded");
                return response.data
            })
            .catch(err => {
                store.commit("Apps/setLoaded");
                if (err.code == 'ERR_BAD_REQUEST'){
                    //if (authHandle) emitter.emit("showMessageBox",i18n.global.t('操作超時，請重新登入'));
                    store.commit("UserProfile/reset");
                    router.push({ name:"Login"} );
                    //return 401
                }
                //apiErrorHandler(err)
            })
    },
    post(path, data, config/*, authHandle=true*/) {
        //store.dispatch('session/sessionTimerRefresh')
        store.commit("Apps/setLoading");
        return httpClient.post(`${SERVICE_PATH}/${path}`, data, config)
            .then(response => {
                store.commit("Apps/setLoaded");
                return response.data
            })
            .catch(err => {
                store.commit("Apps/setLoaded");
                if (err.code == 'ERR_BAD_REQUEST'){
                    //if (authHandle) emitter.emit("showMessageBox",i18n.global.t('操作超時，請重新登入'));
                    store.commit("UserProfile/reset");
                    router.push({ name:"Login"} );
                    //return 401
                }
                //apiErrorHandler(err)
            })
    },
    delete(path) {
        store.commit("Apps/setLoading");
        return httpClient.delete(`${SERVICE_PATH}/${path}`)
            .then(response => {
                store.commit("Apps/setLoaded");
                return response.data
            })
            .catch(err => {
                store.commit("Apps/setLoaded");
                //apiErrorHandler(err)
                print(err);
            })
    },
    put(path, data) {
        store.commit("Apps/setLoading");
        return httpClient.put(`${SERVICE_PATH}/${path}`, data)
            .then(response => {
                store.commit("Apps/setLoaded");
                return response.data
            })
            .catch(err => {
                store.commit("Apps/setLoaded");
                //apiErrorHandler(err)
                print(err);
            })
    }
}

export { SERVICE_PATH, httpClient, request }
